import { lazy } from 'react';

const Leads = lazy(() => import('./LeadsPage'));

const LeadsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'processor/leads',
      element: <Leads />,
      children: [
        {
          path: ':id',
          element: <Leads />,
        },
      ],
    },
  ],
};

export default LeadsConfig;
